import React, {useEffect, useState} from 'react';
import ReactRecaptcha from 'react-recaptcha';
import Grid from '@material-ui/core/Grid';
import TextField from "@material-ui/core/TextField/TextField";
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import Status from './Status';
import arrowIcon from '../../../images/right-arrow.png';
import {trackSubscribe} from '../../../services/gtm';
import {useQueryParam} from "gatsby-query-params";
import arrowImg from "../../../images/link-arrow.png";
import Link from "../../Link";

export default function Form({classes, postData}) {
    const [forename, setForename]                   = useState('');
    const [surname, setSurname]                     = useState('');
    const [email, setEmail]                         = useState('');
    const [telephone, setTelephone]                 = useState('');
    const [postcode, setPostcode]                   = useState('');
    const [dob, setDob]                             = useState('');
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const [termsAccepted, setTermsAccepted]         = useState(false);
    const [status, setStatus]                       = useState({
        state: '',
        msg:   ''
    });
    const [validationErrors, setValidationErrors]   = useState({dob: ["You’ll need to be over 18 to subscribe"]});
    const [formError, setFormError]                 = useState([]);
    const [formSubmitted, setFormSubmitted]         = useState(false);
    const [formSending, setFormSending]             = useState(false);

    const crmId = useQueryParam('house', null);

    useEffect(() => {
        validateAge();
    }, [dob]) // eslint-disable-line

    function isOver18() {
        const selectedDate = new Date(dob).getTime();
        const now          = new Date().getTime();
        const difference   = Math.abs(Math.round(((now - selectedDate) / 1000) / (60 * 60 * 24 * 7 * 4)));
        const monthsTo18   = 18 * 12;
        return difference > monthsTo18;
    }

    function validateAge() {
        if (dob && isOver18()) {
            let newErrors = {...validationErrors};
            if (newErrors.hasOwnProperty('dob')) {
                delete newErrors['dob'];
            }
            setValidationErrors(newErrors)
            return true;
        }

        setValidationErrors({...validationErrors, "dob": "You'll need to be over 18 to subscribe"});
        return false;
    }

    function validateTermsAccepted() {
        if (!termsAccepted) {
            setValidationErrors({...validationErrors, "terms": "You must read and accept the Terms and Conditions to continue."});
            return false;
        }
        return true;
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!validateAge() || !validateTermsAccepted()) return;

        let formData = {
            forename,
            surname,
            email,
            telephone,
            postcode,
            dob,
            source_details:         'Website Brand Vacancy Subscribe Form',
            "g-recaptcha-response": recaptchaResponse,
        };

        setStatus({
            state: 'pending',
            msg:   'We are processing your signup'
        });

        setFormSending(true);

        postData(formData)
            .then(response => {
                if (Boolean(response.data.success)) {
                    trackSubscribe();
                    setFormSubmitted(true);
                }
                setFormSending(false);
            })
            .catch(error => {
                let errorMessage = 'There was a problem submitting your details. Please try again later.';
                if (error.hasOwnProperty('response')) {
                    if (error.response) {
                        console.log('Response', error.response);
                        if (error.response.data.hasOwnProperty('message')) {
                            setValidationErrors([]);
                            errorMessage = error.response.data.message;
                        } else if (error.response.data.hasOwnProperty('validation')) {
                            setValidationErrors(error.response.data.validation);
                            errorMessage = 'Please check the form for errors.';
                        }
                    } else if (error.request) {
                        console.log('Request', error.request);
                    } else {
                        console.log('Setup', error.message);
                    }
                }

                setFormError(errorMessage);
                setFormSending(false);
            });
    }

    return <div className="form-wrapper">
        {formSubmitted && <p className={classes.thanks}><CheckCircleIcon/> Thank you for subscribing to our vacancy
            alerts. You will now get notified on our most recent pub vacancies as they are listed... sit back and
            let your perfect pub find you!</p>}

        {!formSubmitted && formError.length != 0 &&
        <p className={classes.errors}><WarningIcon/> {formError}</p>
        }
        {!formSubmitted && <form className={classes.Form} onSubmit={handleSubmit}>
            <fieldset className={classes.Fields}>
                <Grid container direction="row" justify="center">
                    <Grid item xs={12} md={10} lg={8}>
                        <Status status={status}/>
                    </Grid>
                    <Grid item xs={12} md={1}/>

                    <Grid item xs={12} md={5} lg={4}>
                        <div className={classes.Field}>
                            <label htmlFor="forename" className={classes.Label}>
                                First Name
                            </label>
                            <input id="forename" name="forename" className={classes.Input} placeholder="your name"
                                   required value={forename}
                                   onChange={(e) => setForename(e.target.value)}/>
                            {validationErrors.forename &&
                            <p className={classes.validationError}>{validationErrors.forename}</p>}
                        </div>
                    </Grid>
                    <Grid item xs={12} md={1}/>
                    <Grid item xs={12} md={5} lg={4}>
                        <div className={classes.Field}>
                            <label htmlFor="surname" className={classes.Label}>
                                Last Name
                            </label>
                            <input id="surname" name="name" className={classes.Input} placeholder="your last name"
                                   required value={surname}
                                   onChange={(e) => setSurname(e.target.value)}/>
                            {validationErrors.surname &&
                            <p className={classes.validationError}>{validationErrors.surname}</p>}
                        </div>
                    </Grid>

                    <Grid item xs={12} md={5} lg={4}>
                        <div className={classes.Field}>
                            <label htmlFor="email" className={classes.Label}>
                                Email Address
                            </label>
                            <input type="email" id="email" className={classes.Input} name="email"
                                   placeholder="example@google.com" required value={email}
                                   onChange={(e) => setEmail(e.target.value)}/>
                            {validationErrors.email &&
                            <p className={classes.validationError}>{validationErrors.email}</p>}
                        </div>
                    </Grid>
                    <Grid item xs={12} md={1}/>
                    <Grid item xs={12} md={5} lg={4}>
                        <div className={classes.Field}>
                            <label htmlFor="telephone" className={classes.Label}>
                                Telephone
                            </label>
                            <input type="text" id="telephone" className={classes.Input} name="telephone"
                                   placeholder="01234 567890" required value={telephone}
                                   onChange={(e) => setTelephone(e.target.value)}/>
                            {validationErrors.telephone &&
                            <p className={classes.validationError}>{validationErrors.telephone}</p>}
                        </div>
                    </Grid>

                    <Grid item xs={12} md={5} lg={4}>
                        <div className={classes.Field}>
                            <label htmlFor="postcode" className={classes.Label}>
                                Postcode
                            </label>
                            <input type="text" id="postcode" className={classes.Input} name="postcode"
                                   placeholder="AB1 2CD" required value={postcode}
                                   onChange={(e) => setPostcode(e.target.value)}/>
                            {validationErrors.postcode &&
                            <p className={classes.validationError}>{validationErrors.postcode}</p>}
                        </div>
                    </Grid>

                    <Grid item xs={12} md={1}/>
                    <Grid item xs={12} md={5} lg={4}>
                        <div className={`${classes.Field}`}>
                            <label htmlFor="dob" className={classes.Label}>
                                Date of Birth
                            </label>
                            <input type="date" id="dob" name="dob" placeholder="01/01/1900" required value={dob}
                                   className={`${classes.Input} ${status.state === 'underage' ? 'error' : ''}`}
                                   onChange={(e) => setDob(e.target.value)}/>
                            {validationErrors.dob && <p className={classes.validationError}>{validationErrors.dob}</p>}
                        </div>
                    </Grid>

                    <Grid item xs={12} md={10} lg={8}>
                        <div className={`${classes.Field}`}>
                            <p className="disclaimer">Robinsons take your privacy very seriously & is committed to protecting your personal information.
                                If you would like further information on how we process your data, please see our <Link to='/privacy-policy'>Privacy Policy</Link></p>
                            <label htmlFor="terms" className={classes.Option}>
                                <input type="checkbox" id="terms" className={classes.Input} name="terms"
                                       required checked={termsAccepted}
                                       onChange={(e) => setTermsAccepted(e.target.checked)}/>
                                <span className="checkmark"></span>
                                I have read and accept the <Link to='/terms-conditions/'>Terms and Conditions</Link>
                            </label>
                            {validationErrors.terms && <p className={classes.validationError}>{validationErrors.terms}</p>}
                        </div>
                    </Grid>

                    <Grid item xs={12} md={6} lg={5}/>
                    <Grid item xs={12} md={5} lg={4}>
                        {/*<ReactRecaptcha className={classes.recaptcha}
                            sitekey={process.env.GATSBY_GRECAPTCHA_KEY}
                            render="explicit"
                            verifyCallback={(res) => setRecaptchaResponse(res)}
                          />*/}

                        <button type="submit" className={classes.Submit}>
                            Submit
                            <img src={arrowIcon} alt="Search" width={14} height={15} />
                        </button>
                    </Grid>
                </Grid>
            </fieldset>
        </form>}
    </div>
};
